import { Autoplay, Navigation } from 'swiper';
import { swiperOnResize } from '../utils/swiperOnResize.utils.js';
let ourJobsSwiperWr = document.querySelectorAll('.our-jobs-swiper-wr');
ourJobsSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');
    swiperOnResize('(max-width: 768px)', swiperEl,
        {
          modules: [Autoplay, Navigation],
          slidesPerView: 1,
          spaceBetween: 20,
          speed: 800,
          autoplay: {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          },
          breakpoints: {
            500: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 1,
            },
            1024: {
              slidesPerView: 1,
            }
          },
          navigation: {
            prevEl: prevEl,
            nextEl: nextEl,
          },
        },
    );
  }
});